import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextInput,
} from '@met/react-components';
import React, { useEffect, useRef, useState } from 'react';

const AddKeyModal = ({ hidden, toggle, onSaveClick }) => {
  const [key, setKey] = useState('');
  const [value, setValue] = useState('');
  const keyInputRef = useRef(null);

  useEffect(() => {
    if (!hidden) keyInputRef.current.focus();
  }, [hidden, keyInputRef]);

  const handleSaveClick = () => {
    onSaveClick(key, value)
      .then(() => setKey(''))
      .then(() => setValue(''))
      .then(() => toggle());
  };

  const handleKeyValueKeyPress = event => {
    if (event.key === 'Enter') {
      handleSaveClick();
    }
  };

  return (
    <Modal centered hidden={hidden} toggle={toggle}>
      <ModalContent>
        <ModalHeader toggle={toggle}>Add Key</ModalHeader>
        <ModalBody>
          <p>
            Add a key. The recommended convention is alpha numeric characters
            and periods. For example, "home.pageTitle".
          </p>
          <TextInput
            inputRef={keyInputRef}
            placeholder='Key'
            value={key}
            onChange={e => setKey(e.target.value)}
          />
          <br />
          <TextInput
            placeholder='Reference Value (English)'
            value={value}
            onKeyPress={handleKeyValueKeyPress}
            onChange={e => setValue(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggle}>Close</Button>
          <Button primary onClick={handleSaveClick}>
            Save Changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddKeyModal;
